import React, { useEffect, useState } from "react";
import BomComment from "./BomComment";
import InputGoods from "./InputGoods";
import "./billOfMaterial.scss";
import {
  BomHeaderType,
  BomInputType,
  BomTotalType,
  SelectOption,
} from "../../../../commonTypes/billOfMaterial";
import { changeToDecimel } from "../../../../utils/commonFunctions";

type AppProps = {
  inputData: BomInputType[];
  addMoreData: (type: string) => void;
  commentData: string;
  templateId?: string;
  total: {
    input: BomTotalType;
    output: BomTotalType;
  };
  branchOption: SelectOption[];
  fetching: boolean;
  currencySign: string | undefined;
  checkStockItemTypeBottom: () => void;
  setStockItemText: any;
  bomHeaderData: BomHeaderType;
  allStockItemOption: SelectOption[];
  setTotal: React.Dispatch<
    React.SetStateAction<{
      input: BomTotalType;
      output: BomTotalType;
    }>
  >;
  handleInputChange: (
    e: any,
    type: string,
    inputType: string,
    index: number
  ) => void;
  handleComment: (e: any) => void;
  deleteData: (type: string, index: number) => void;
  handlePrimaryDetails: (e: any, index: number) => void;
  checkBranchTypeBottom: () => void;
  allBatchOption: any;
  handletoggleRowInput: (item: number, data: any)
    => void;
  handleGetSelectedbatch: (data1: any, data2: any, type: string) => void;
  autoUniqueNumberGenerationData: any;
  toggleExpandCollapseItems: (type: string, action: string) => void;
  batchFetching:boolean;
  isMenuOpen:boolean;

};

const BomInput = ({
  total,
  setTotal,
  inputData,
  templateId,
  addMoreData,
  deleteData,
  currencySign,
  commentData,
  handleComment,
  branchOption,
  fetching,
  bomHeaderData,
  checkStockItemTypeBottom,
  setStockItemText,
  allStockItemOption,
  handleInputChange,
  handlePrimaryDetails,
  checkBranchTypeBottom,
  allBatchOption,
  handletoggleRowInput,
  handleGetSelectedbatch,
  autoUniqueNumberGenerationData,
  toggleExpandCollapseItems,
  batchFetching,
  isMenuOpen


}: AppProps) => {
  useEffect(() => {
    if (inputData?.length > 0) {
      let amount = 0;
      let qty = 0;
      inputData?.map((item: BomInputType) => {
        amount += +item.amount;
        qty += +item?.quantity;
      });
      setTotal((prev: any) => ({ ...prev, input: { qty, amount } }));
    }
  }, [inputData]);

  return (
    <div className="bomInput">
      <div className="input">
        <InputGoods
          inputData={inputData}
          fetching={fetching}
          templateId={templateId}
          addMoreData={addMoreData}
          deleteData={deleteData}
          checkStockItemTypeBottom={checkStockItemTypeBottom}
          setStockItemText={setStockItemText}
          branchOption={branchOption}
          allStockItemOption={allStockItemOption}
          handleInputChange={handleInputChange}
          bomHeaderData={bomHeaderData}
          currencySign={currencySign}
          handlePrimaryDetails={handlePrimaryDetails}
          checkBranchTypeBottom={checkBranchTypeBottom}
          allBatchOption={allBatchOption}
          handletoggleRowInput={handletoggleRowInput}
          handleGetSelectedbatch={handleGetSelectedbatch}
          autoUniqueNumberGenerationData={autoUniqueNumberGenerationData}
          toggleExpandCollapseItems={toggleExpandCollapseItems}
          batchFetching={batchFetching}
          isMenuOpen={isMenuOpen}
        />
      </div>
      <div className="totalAmount">
        <div className="totalQty">
          {inputData?.length === 0
            ? 0
            : !!total?.input?.qty
              ? total?.input?.qty?.toString()?.includes(".")
                ? total?.input?.qty?.toFixed(2)
                : total?.input?.qty
              : 0}{" "}
          Qty
        </div>

        <div className="totalAmt">
          {currencySign}{" "}
          {!!total?.input?.amount ? changeToDecimel(+total?.input?.amount) : 0}
        </div>
      </div>
    </div>
  );
};

export default BomInput;
